/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon16Light = forwardRef('ArrowDRadiusDownLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14 2.5A5.5 5.5 0 0 1 8.5 8H2.207l3.647-3.646a.5.5 0 1 0-.708-.708L1.495 7.298a1.7 1.7 0 0 0 0 2.404l3.651 3.652a.5.5 0 0 0 .708-.708L2.207 9H8.5A6.5 6.5 0 0 0 15 2.5a.5.5 0 1 0-1 0Z" })));
});
